import { render, staticRenderFns } from "./RegisterRoutePage.vue?vue&type=template&id=1b193d52&"
import script from "./RegisterRoutePage.vue?vue&type=script&lang=js&"
export * from "./RegisterRoutePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports